export const QUOTE_QUANTITY = 5;
export const THEMES = 7;
export const ANALYTICS_CODE = 'UA-283964-52';



/** WEBPACK FOOTER **
 ** ./src/js/constants/config.js
 **/